import {MAX_SCREEN_WIDTH} from '@/theme/theme'
import styled from 'styled-components'

export const NavigationBar = styled.nav`
    position: sticky;
    top: 0;
    z-index: 1000;
    display: flex;
    width: 100%;
    background-color: ${(props) => props.theme.navigationResponsive.dataArea.background};
    color: ${(props) => props.theme.navigationResponsive.dataArea.textColor};
`

export const Content = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: ${MAX_SCREEN_WIDTH}px;
    margin: auto;

    @media (max-width: ${MAX_SCREEN_WIDTH}px) {
        padding-inline: 16px;
    }
`
